"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSelectedContext = exports.TableContext = void 0;
const react_1 = require("react");
exports.TableContext = react_1.createContext(undefined);
exports.TableSelectedContext = react_1.createContext(undefined);
//# sourceMappingURL=table-context.js.map